import moment from 'moment';

export const formatDate = (date: Date, defaultFormat = 'DD/MM/YYYY') => {
    return date ? moment(date).format(defaultFormat) : '';
};
